import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "numberToReadable",
  standalone: true,
})
export class NumberToReadablePipe implements PipeTransform {
  public transform(value: number, decimals: number = 1): string {
    if (value === null || value === undefined) {
      return "";
    }

    const absValue = Math.abs(value);

    if (absValue < 1000) {
      return value.toString();
    }

    const suffixes = ["K", "M", "B", "T"]; // For thousand, million, billion, trillion
    let suffixIndex = -1;
    let newValue = value;

    while (newValue >= 1000 && suffixIndex < suffixes.length - 1) {
      newValue /= 1000;
      suffixIndex++;
    }

    return newValue.toFixed(decimals) + " " + suffixes[suffixIndex];
  }
}
